import api from '../../../api';

const API_URL = '/crm/chart-of-accounts';

export async function getChartOfAccounts() {
  const res = await api.get(API_URL);
  return res.data;
}

export async function getChartOfAccount(id) {
  const res = await api.get(API_URL + '/' + id);
  return res.data;
}

export async function createChartOfAccount(data) {
  const res = await api.post(API_URL, data);
  return res.data;
}

export async function updateChartOfAccount(id, data) {
  const res = await api.put(API_URL + '/' + id, data);
  return res.data;
}

export async function deleteChartOfAccount(id) {
  return api.delete(API_URL + '/' + id);
}
